import React from "react";
import imgLeft from "../../Assets/Blog Details/certificate.png";
import imgRight from "../../Assets/Blog Details/award.png";

const BodyContent = () => {
  return (
    <div className="w-full px-4 md:px-10 py-4 grid gap-4">
      <div>
        <h3 className="text-gray-900 font-medium text-[20px] w-full xl:w-[872px]">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s,
        </h3>
      </div>

      <div className="py-2">
        <p className="text-gray-500 text-lg w-full xl:w-[872px]">
          when an unknown printer took a galley of type and scrambled it to make
          a type specimen book. It has survived not only five centuries, but
          also the leap into electronic typesetting, remaining essentially
          unchanged.
        </p>
      </div>

      <div>
        <p className="text-gray-500 text-lg w-full xl:w-[872px]">
          It was popularised in the 1960s with the release of Letraset sheets
          containing Lorem Ipsum passages, and more recently with desktop
          publishing software like Aldus PageMaker including versions of Lorem
          Ipsum.Contrary to popular belief, Lorem Ipsum is not simply random
          text. Richard McClintock, a Latin professor at Hampden-Sydney College
          in Virginia, looked up one of the more obscure Latin words,
          consectetur, from a Lorem Ipsum passage, and going through the cites
          of the word in classical literature, discovered the undoubtable
          source.
        </p>
      </div>

      <div className="w-full xl:w-[872px] grid grid-cols-1 md:grid-cols-2 gap-4 py-4">
        <div className="grid">
          <img
            src={imgLeft}
            alt="Certificate"
            className="h-[400px] w-full object-cover rounded-lg"
          />
        </div>
        <div className="grid">
          <img
            src={imgRight}
            alt="Award"
            className="h-[400px] w-full object-cover rounded-lg"
          />
        </div>
      </div>

      <div>
        <p className="text-gray-500 text-lg w-full xl:w-[872px]">
          There are many variations of passages of Lorem Ipsum available, but
          the majority have suffered alteration in some form, by injected
          humour, or randomised words which don't look even slightly
          believable.If you are going to use a passage of Lorem Ipsum, you need
          to be sure there isn't anything embarrassing hidden in the middle of
          text.
        </p>
      </div>
    </div>
  );
};

export default BodyContent;
